import { saveExcel } from "../../../utils/saveExcel";
import { useDispatch } from "react-redux";
import { downloadLeadsList } from "../../../actionCreator/leadListingActionCreater";
import { savePDF } from "../../../utils";
import { useAlert } from "../../../context/AlertProvider";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { FileSpreadsheet, FileText } from "lucide-react";

const columns = [
  { header: "Serial No.", key: "serealNo" },
  { header: "FirstName", key: "firstName" },
  { header: "LastName", key: "lastName" },
  { header: "Designation", key: "designation" },
  { header: "Email Available", key: "email" },
  { header: "Company Name", key: "name" },
  { header: "Phone", key: "phoneNo" },
];

export const useExport = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { isAuthenticated } = useContext(AuthContext);

  const onExport = async (selectedRecords, type) => {
    if (isAuthenticated) {
      if (selectedRecords?.length) {
        const res = await dispatch(downloadLeadsList(selectedRecords, type));
        if (res?.response?.status === 403) {
          showAlert(
            "warning",
            "Permission Denied",
            "You do not have permission to download leads data.",
          );
        }
        if (res?.length) {
          const downloadedUpdatedData = getSchema(res);
          const fileName = "Client Leads Data";
          if (type === "exl") {
            saveExcel(downloadedUpdatedData, columns, fileName);
          } else {
            savePDF(downloadedUpdatedData, columns, fileName);
          }
          showAlert(
            "success",
            "Download Complete",
            <div>
              Your Client Leads has been successfully downloaded to{" "}
              {type === "exl" ? (
                <FileSpreadsheet size={16} className="tw-text-[#4CAF50] tw-inline tw-ml-1" />
              ) : (
                <FileText size={16} className="tw-text-[#f44336] tw-inline tw-ml-1" />
              )}
              .
            </div>,
          );
        }
      } else {
        showAlert("warning", "please select record.");
      }
    }
  };

  const getSchema = (data) => {
    var finaldata = [];
    let cnt = 0;
    data.forEach((obj) => {
      cnt++;
      var dataObj = {};
      dataObj.id = obj.id;
      dataObj.serealNo = cnt;
      dataObj.firstName = obj.firstname;
      dataObj.lastName = obj.lastname;
      dataObj.designation = obj.title;
      dataObj.email = obj.emailId;
      dataObj.name = obj?.companyName;
      dataObj.phoneNo = obj.phoneNo;
      finaldata.push(dataObj);
    });
    return finaldata;
  };

  return { onExport, getSchema, columns };
};
